import { url } from './url';

export const columns = [url];
